
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Cabserviceinchakan() {



    const cardData =
    {
        keyword: 'Cab Service In Chakan',
        heading: 'Mauli Cabs: Cab Service In Chakan',
        headingDescription: 'Mauli Cabs offers dependable and affordable cab service in Chakan, catering to both local and outstation travel needs with ease. Whether you are commuting for work, planning a family outing, or need a ride to the airport, we provide a range of clean and well-maintained vehicles including hatchbacks, sedans, SUVs, and tempo travellers. With professional drivers, transparent pricing, timely service, and a customer-first approach, Mauli Cabs ensures a smooth and safe journey every time. Trust Mauli Cabs for a reliable cab experience in and around Chakan.',

        top: 'Top Places to Visit in Chakan Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Cab Service in Chakan",
      "description": "Get reliable and efficient cab service in Chakan for all your travel needs. Whether it's a local trip, airport transfer, or outstation journey, we offer comfortable rides with professional drivers for a hassle-free experience."
    },
    {
      "name": "Book Taxi in Chakan",
      "description": "Easily book a taxi in Chakan with our convenient online booking system. Choose from a variety of vehicle options, whether you're heading for a short local ride or a longer outstation journey."
    },
    {
      "name": "Affordable Cab in Chakan",
      "description": "Looking for an affordable cab in Chakan? We provide budget-friendly taxi services with no hidden charges, ensuring a cost-effective solution for all your travel requirements."
    },
    {
      "name": "Private Taxi Hire Chakan",
      "description": "Hire a private taxi in Chakan for a comfortable and exclusive travel experience. Whether it's a business trip or a leisure ride, enjoy the privacy and convenience of our top-class vehicles."
    },
    {
      "name": "Chakan Car Rental Service",
      "description": "Rent a car in Chakan for your local or outstation travel needs. Our car rental service offers a wide range of vehicles with flexible rental options to suit your preferences and budget."
    },
    {
      "name": "Chakan Local and Outstation Cabs",
      "description": "Book a cab for local and outstation trips in Chakan. Our fleet of well-maintained vehicles and experienced drivers ensure a smooth and reliable ride, whether you're traveling within the city or going on a long-distance journey."
    },
    {
      "name": "Reliable Cab Company in Chakan",
      "description": "Choose our reliable cab company in Chakan for timely and professional taxi services. With well-maintained cars and experienced drivers, we ensure that your ride is safe, comfortable, and punctual."
    },
    {
      "name": "Comfortable Cab Ride in Chakan",
      "description": "Experience a comfortable and pleasant ride in Chakan with our premium taxi services. Whether you're traveling alone or with a group, we provide a range of vehicles to ensure a smooth journey."
    },
    {
      "name": "Chakan to Pune Taxi",
      "description": "Book a taxi from Chakan to Pune for a seamless journey. Our reliable service ensures timely pickups, comfort, and safety for all passengers traveling between Chakan and Pune."
    },
    {
      "name": "Group Travel by Cab in Chakan",
      "description": "Travel with your group in comfort by booking a cab in Chakan. Our spacious vehicles are perfect for group trips, offering enough room for everyone while ensuring a smooth and enjoyable journey."
    }
  ],
  "tableData": [
    ["Cab Service in Chakan", "Book Taxi in Chakan"],
    ["Affordable Cab in Chakan", "Private Taxi Hire Chakan"],
    ["Chakan Car Rental Service", "Chakan Local and Outstation Cabs"],
    ["Reliable Cab Company in Chakan", "Comfortable Cab Ride in Chakan"],
    ["Chakan to Pune Taxi", "Group Travel by Cab in Chakan"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service in Chakan",
        "WhyChoosedescription": "Mauli Cabs offers dependable and on-time cab services in Chakan, catering to your travel needs for both local and outstation journeys."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and AC-Equipped Vehicles",
        "WhyChoosedescription": "Our fleet includes sedans, hatchbacks, and SUVs—all well-maintained, sanitized, and air-conditioned for a smooth and pleasant ride."
    },
    {
        "WhyChooseheading": "Experienced Local Drivers",
        "WhyChoosedescription": "Our drivers are well-versed with Chakan’s routes and nearby areas, ensuring efficient navigation and safe travel every time."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fare Structure",
        "WhyChoosedescription": "Enjoy fair and upfront pricing with no hidden charges. Mauli Cabs offers cost-effective cab solutions in Chakan for all budgets."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability in Chakan",
        "WhyChoosedescription": "Whether it's early morning or late night, our cabs are available round-the-clock to serve your travel needs in and around Chakan."
    },
    {
        "WhyChooseheading": "Quick Booking and Live Tracking",
        "WhyChoosedescription": "Easily book your cab online or via phone. Track your cab in real-time and stay informed with accurate ETAs and updates."
    },
    {
        "WhyChooseheading": "Sanitized Vehicles and Verified Drivers",
        "WhyChoosedescription": "All our vehicles undergo regular sanitization, and our drivers are background-verified to offer you a safe and hygienic cab experience."
    },
    {
        "WhyChooseheading": "Multiple Payment Modes Accepted",
        "WhyChoosedescription": "Choose from UPI, credit/debit cards, wallets, or cash. We offer flexible and secure payment options for your convenience."
    }
]



















    }

    const faqData = [
        {
            question: 'How do I book a cab in Chakan with Mauli Cabs?',
            answer: 'Booking a cab in Chakan with Mauli Cabs is quick and hassle-free. Just visit our website or mobile app, enter your pickup and drop locations, choose the vehicle type, and confirm the booking. For assistance, our support team is available 24/7.',
        },
        {
            question: 'What types of cabs are available in Chakan?',
            answer: 'Mauli Cabs offers a wide range of vehicles in Chakan including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose as per your group size and comfort needs.',
        },
        {
            question: 'Are Mauli Cabs services in Chakan available 24/7?',
            answer: 'Yes, our cab services in Chakan operate round the clock. Whether it’s an early morning airport drop or a late-night pickup, we ensure timely service at any hour.',
        },
        {
            question: 'Can I book a cab for local and outstation travel from Chakan?',
            answer: 'Absolutely. You can book a cab for both local travel within Chakan and outstation trips to cities like Pune, Mumbai, Nashik, and more.',
        },
        {
            question: 'Is the fare for cab services in Chakan fixed?',
            answer: 'Yes, we provide transparent and fixed pricing. Your fare includes fuel, tolls, driver charges, and taxes—there are no hidden fees.',
        },
        {
            question: 'Can I schedule a cab in advance in Chakan?',
            answer: 'Yes, Mauli Cabs allows advance booking. Schedule your ride in Chakan at your preferred date and time through our app or website.',
        },
    ];
    
    
    
    
    const testimonials = [
        {
            name: "Mr. Pratik Mhatre",
            position: "Project Consultant",
            text: "I booked a cab from Goregaon to Pune for a client meeting. The cab arrived on time, the driver was courteous, and the car was very comfortable. Will book again without hesitation!",
            image: "/img/testimonial/testimonial-thumb-1-47.png",
        },
        {
            name: "Mrs. Kavita Salunke",
            position: "College Lecturer",
            text: "Used Mauli Cabs for travel from Goregaon to Pune. The booking process was smooth and the journey was safe and relaxing. Highly satisfied with the service!",
            image: "/img/testimonial/testimonial-thumb-1-48.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Goregaon to Pune Cab",
        "description": "Mauli Cabs provides a convenient and affordable taxi service from Goregaon to Pune. Choose from Innova Crysta, Ertiga, and sedan cabs for a comfortable journey to various destinations like Pimpri Chinchwad, Hinjewadi, and Swargate.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5465"
        }
      };
      
     
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Goregaon to Pune Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a cab from Goregaon to Pune with Mauli Cabs. Choose from Innova Crysta, Ertiga, and sedan cabs for an affordable and comfortable ride. We offer one-way and round-trip options to various destinations."
        />
        <meta
          name="keywords"
          content="Goregaon to Pune Pimpri Chinchwad cab, goregaon to pune one way cab, goregaon to pune taxi service, taxi service in Goregaon Mumbai, cabs service Goregaon Mumbai, malad to pune cab services, Oshiwara Andheri to Pune taxi booking, goregaon to hinjewadi cabs, goregaon to pune station cabs, goregaon to pune station taxi fare, taxi services from goregaon to pune station, innova crysta on rent goregaon mumbai, cabs service in goregaon, innova crysta on rent in goregaon mumbai, goregaon to pimpri chinchwad cab, goregaon to pimpri chinchwad cab fare, goregaon to swargate cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/146.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinchakan;